<template>
  <div class="icon-wrapper">
    <svg
      :class="{ active: isActive }"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 734 975"
    >
      <title>Selected file</title>
      <path
        :class="['file-icon', isActive ? 'active' : '']"
        d="M878,332.23v590a80.81,80.81,0,0,1-80.8,80.8H224.8A80.81,80.81,0,0,1,144,922.2V108.8A80.81,80.81,0,0,1,224.8,28H571.6a3.4,3.4,0,0,1,3.4,3.4V291.2A37.8,37.8,0,0,0,612.8,329h262A3.23,3.23,0,0,1,878,332.23Z"
        transform="translate(-144 -28)"
      />
      <path
        :class="['file-icon', isActive ? 'active' : '']"
        d="M632,28V269H878V258.28a36.41,36.41,0,0,0-10.9-26L671.43,40.21A42.59,42.59,0,0,0,641.58,28Z"
        transform="translate(-144 -28)"
      />
    </svg>
    <div class="details" v-if="isActive">
      <span>file name:</span>
      <br />
      {{ file.name }}
      <br />
      <span>file size:</span>
      <br />
      {{ file.size }}
    </div>
    <a v-if="file.URL" class="a-button" :href="file.URL" :download="file.name">Save file</a>
  </div>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
    file: Object
  }
};
</script>

<style lang="scss" scoped>
.icon-wrapper {
  display: grid;
  grid-auto-columns: 1fr 3fr 1fr;
  svg {
    position: relative;
    left: 0;
    max-height: 100px;
    &.active {
      padding-top: 6px;
      max-height: 140px;
    }
    .file-icon {
      grid-column: 1;
      fill: $primary;
      stroke: $dark;
      stroke-width: 10;
      transition: fill 1s ease-in-out;
      &.active {
        fill: $light;
        stroke: none;
      }
    }
  }

  .a-button {
    grid-column: 3;
    color: $light;
    background: linear-gradient(280deg, $secondary 50%, #fff 50%);
    padding: 20px;
    padding-top: 23px;
    margin: 30px;
    font-size: 1.3em;
    width: 150px;
    max-height: 70px;
    display: inline-block;
    text-align: center;
    text-decoration: none;
    box-sizing: border-box;
    border-radius: 45px;
    @include BoxShadow(4);
    cursor: pointer;
    &:hover {
      @include BoxShadow(8);
    }
    &::after {
      background: linear-gradient(280deg, #fff 50%, $secondary 50%);
    }
    &,
    &::after {
      background-size: 300%;
      background-position: 100%;
      transition: background-position 0.5s ease-in-out, color 0.5s ease-in-out;
    }
    &:hover,
    &:hover::after {
      color: $secondary;
      background-position: 0;
    }
  }

  .details {
    position: relative;
    padding: 20px;
    grid-column: 2;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    max-width: 100%;
    color: $secondary;
    span {
      color: $light;
    }
  }
}

@media screen and (max-width: 700px) {
  .icon-wrapper {
    svg.active {
      position: absolute;
      top: 65px;
      left: 75px;
      opacity: 0.2;
      .file-icon {
        fill: $dark;
      }
    }
    .details {
      padding: 0;
      margin-left: 0;
      left: -25px;
      width: 30vw;
    }
  }
}
</style>